




































































































import { GuildsApi } from '@/services/api/api.guilds';
import { GuildBankEventLogTypes, GuildBankTabViewObject, GuildViewObject } from '@/types/apiServerContract';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Tabs from '@/core/layout/Tabs/Tabs.vue';
import Tab from '@/core/layout/Tabs/Tab.vue';

@Component({
    components: { Tabs, Tab }
})
export default class GuildBankTabs extends Vue {
    @Prop({ required: true, type: Number })
    realmId!: number;

    @Prop({ required: true, type: Object })
    guild!: GuildViewObject;

    tabs: GuildBankTabViewObject[] = [];
    activeTab: GuildBankTabViewObject | null = null;
    term: string = '';

    get logTypes() {
        return {
            DEPOSIT_ITEM: GuildBankEventLogTypes.GUILD_BANK_LOG_DEPOSIT_ITEM,
            WITHDRAW_ITEM: GuildBankEventLogTypes.GUILD_BANK_LOG_WITHDRAW_ITEM,
            MOVE_ITEM: GuildBankEventLogTypes.GUILD_BANK_LOG_MOVE_ITEM,
            DEPOSIT_MONEY: GuildBankEventLogTypes.GUILD_BANK_LOG_DEPOSIT_MONEY,
            WITHDRAW_MONEY: GuildBankEventLogTypes.GUILD_BANK_LOG_WITHDRAW_MONEY,
            REPAIR_MONEY: GuildBankEventLogTypes.GUILD_BANK_LOG_REPAIR_MONEY
        };
    }

    get activeTabItems() {
        const term = this.term.toLowerCase();
        const items = this.activeTab?.items ?? [];
        return (term
            ? items.filter(x => x.item.name.toLowerCase().includes(term) || x.entry.toString() === term)
            : items) ?? [];
    }

    get activeTabMoneyLogs() {
        return this.activeTab?.moneyLogs ?? [];
    }

    get activeTabItemLogs() {
        return this.activeTab?.itemLogs ?? [];
    }

    isActiveTab(tab: GuildBankTabViewObject) {
        return this.activeTab?.tabId === tab.tabId;
    }

    getMoneyLog(money: number) {
        const gold = Math.floor(money / 10000);
        const silver = Math.floor((money % 10000) / 100);
        const copper = (money % 10000) % 100;
        return `${gold > 0 ? gold + ' <font color=\'gold\'>Gold</font> ' : ''}
                ${silver > 0 ? silver + ' <font color=\'silver\'>Silver</font> ' : ''} 
                ${copper > 0 ? copper + ' <font color=\'orange\'>Copper</font> ' : ''}`;
    }

    getOtherBankTab(tabId: number) {
        const otherTab = this.tabs.find(x => x.tabId === tabId);
        return otherTab ? otherTab.tabName : 'Unknown Tab';
    }

    loading: boolean = false;

    async getGuildBankTabs() {
        this.loading = true;

        try {
            const result = await GuildsApi.GetGuildBankTabs(this.realmId, this.guild.id);
            this.tabs = result.tabs;
            this.activeTab = result.tabs[0];
        } finally {
            this.loading = false;
        }
    }

    selectTab(tab: GuildBankTabViewObject) {
        this.activeTab = tab;
    }

    getTabIcon(tab: GuildBankTabViewObject) {
        return `background-image: url('${tab.tabIcon}');`;
    }

    created() {
        this.getGuildBankTabs();
    }
}
